import { useContext, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import DashboardContext from '../../Context';
import PropTypes from 'prop-types';
/**
 * این کامپوننت برای نمایش دکمه افزودن و لغو در فرم های و صفحات است
 * اگر کاربر دسترسی داشته باشد نمایش داده می شود
 */
export default function CreateCancel({ ismicro }) {
  const {
    accessPage,
    handelEdit,
    handelAdd,
    SohwaddFrom,
    handeldmicro,
    HandlechangeNumber,
  } = useContext(DashboardContext);
  const [loading, setloading] = useState(false);

  const handelEditform = (id) => {
    if (ismicro) {
      handeldmicro(false);
    } else {
      handelAdd(false);
    }
    handelEdit(id);
  };

  const additem = () => {
    if (ismicro) {
      handeldmicro(true);
    } else {
      handelAdd(true);
    }
  };
  useEffect(() => {
    setloading(true);
    //console.log(accessPage?.includes("Create"));
    setloading(false);
  }, []);

  return !loading ? (
    <Row>
      <Col md={12} sm={12} xs={12}>
        {SohwaddFrom ? (
          <Button
            variant='warning'
            className='mb-3'
            style={{
              border: '1px solid #000000'
            }}
            onClick={() => {
              HandlechangeNumber(false);
              handelEditform('');
            }}
          >
            بازگشت
          </Button>
        ) : accessPage?.includes('Create') ? (
          <button
            type='button'
            className='btn btn-primary btn-icon-text btn-sm mb-3'
            onClick={additem}
          >
            افزودن <i className='fa fa-plus fa-lg'></i>
          </button>
        ) : null}
      </Col>
    </Row>
  ) : (
    <></>
  );
}
CreateCancel.propTypes = {
  /**اگر باشد یعنی در جای کوچک ویا فرعی استفاده شده است */
  ismicro: PropTypes.bool,
};
